import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {findDOMNode } from 'react-dom'
import _ from 'lodash'

import * as config from '../../config'
import { TicketTooltip, GASelector } from './tooltips'

/* eslint import/no-webpack-loader-syntax: off */
import skeletonCSS from  '!css-loader!../../styles/skeleton.css'
import normalizeCSS from  '!css-loader!../../styles/normalize.css'
import widgetCSS from  '!css-loader!../../styles/index.css'
import seatmapCSS from  '!css-loader!./seatmap.css'


export default class SeatMapEditor extends Component {
    constructor (props) {
        super(props);
        this.smEventId = props.smEventId;
        this.smPublicKey = config.SEATMAP_PUBLIC_KEY;
        this.smLibUrl = config.SEATMAP_LIB_URL;
        this.state = {
            showSeatsWithPrices: true,
            showSeatsWithoutPrices: false,
            showSeatsWithoutTickets: false,
        }
    }

    render() {
        return (
            <React.Fragment>
                <iframe
                    title="Редактирование мест"
                    className='seatmap-container'> 
                </iframe>
                <div className='row'>
                    <div className='six columns'>
                        <label>
                            <input type="checkbox"
                                checked={this.state.showSeatsWithPrices}
                                onChange={this.handleShowSeatsWithPrices}/>
                            <span className="label-body">Места с ценами</span>
                        </label>
                        <label>
                            <input type="checkbox"
                                checked={this.state.showSeatsWithoutPrices}
                                onChange={this.handleShowSeatsWithoutPrices}/>
                            <span className="label-body">Места без цен</span>
                        </label>
                        <label>
                            <input type="checkbox"
                                checked={this.state.showSeatsWithoutTickets}
                                onChange={this.handleShowSeatsWithoutTickets}/>
                            <span className="label-body">Места без билетов</span>
                        </label>
                    </div>
                    {this.props.sector ? 
                        <div className='six columns'>
                            <b>Выбранный сектор: {this.props.sector.name}</b>
                            <br />
                            Всего билетов: {this.getSectorTicketsAmount(this.props.sector)} шт.
                            <br />
                            Доступно для покупки: {this.getSectorAvailableTicketsAmount(this.props.sector)} шт.
                            <br />
                        </div> :
                        null
                    }
                </div>
            </React.Fragment>
        )
    }

    componentDidMount() {
        this.prepareAccessToIframe()
        this.initTooltips()
        this.loadSeatmapToIframe()
        this.applyStyles()
    }

    prepareAccessToIframe() {
        this.iframe = findDOMNode(this)
        this.window = this.iframe.contentWindow || this.iframe
        this.document = this.iframe.contentDocument || this.window.document
    }

    initTooltips() {
        this.tooltip = new TicketTooltip(this.document)
        this.gaSelector = new GASelector(this.document, true)
    }

    hideTooltips() {
        if(this.tooltip) this.tooltip.hide()
    }

    applyStyles() {
        const style = this.document.createElement('style')
        style.type = 'text/css'
        style.appendChild(this.document.createTextNode(skeletonCSS.toString()))
        style.appendChild(this.document.createTextNode(normalizeCSS.toString()))
        style.appendChild(this.document.createTextNode(widgetCSS.toString()))
        style.appendChild(this.document.createTextNode(seatmapCSS.toString()))
        this.document.head.appendChild(style)
    }

    loadSeatmapToIframe() {
        const root_div = this.getRootDiv()
        this.loadSeatmapIntoElement(root_div)
    }

    getRootDiv() {
        this.document.write('<div id="root"></div>')
        return this.document.getElementById("root")
    }

    loadSeatmapIntoElement(root_div) {
        const seatmap_script = this.createSMScriptElement()
        seatmap_script.onload = (e) => {
            this.createSeatmapRenderer(root_div)
            this.addZoomButtons()
        }
        this.document.head.appendChild(seatmap_script)
    }

    createSMScriptElement() {
        var sm_lib= this.document.createElement('script')
        sm_lib.src = this.smLibUrl
        sm_lib.async = true
        sm_lib.type = 'text/javascript'
        return sm_lib
    }

    createSeatmapRenderer(root_div) {
        var settings = this.getSMRendererSettings()
        this.window.sm_settings = settings
        this.window.sm_root = root_div
        this.window.sm_event_id = this.smEventId;

        this.window.eval('window.sm_object = new SeatmapBookingRenderer(window.sm_root, window.sm_settings)')
        this.window.eval('window.sm_object.loadEvent(window.sm_event_id)')
        this.smRenderer = this.window.sm_object
    }

    addZoomButtons() {
        const buttonBlock = this.document.createElement('div')
        this.document.body.appendChild(buttonBlock)
        ReactDOM.render(
            <ZoomButtons
                onZoomIn={this.zoomIn} 
                onZoomOut={this.zoomOut} 
            />, buttonBlock)
    }

    getSMRendererSettings() {
        return {
            publicKey: this.smPublicKey,
            onCartChange: (cart) => {
                this.props.onChange(cart.seats)
            },
            onSeatMouseEnter: (seat) => {
                this.showSeatTooltip(seat)
            },
            onSeatSelect: (seat) => {
                this.showSeatTooltip(seat)
            },
            onSectorClick: (sector) => {
                this.showGaTooltip(sector)
            },
            onSectorMouseLeave: () => {
                this.tooltip.hide()
            },
            env: config.SEATMAP_ENVIRONMENT,
        }
    }

    zoomIn = () => {
        this.smRenderer.zoomIn()
        this.hideTooltips()
    }

    zoomOut = () => {
        this.smRenderer.zoomOut()
        this.hideTooltips()
    }

    handleShowSeatsWithPrices = () => {
        this.setState({showSeatsWithPrices: !this.state.showSeatsWithPrices})
        this.updateSeatsAvailability(
            !this.state.showSeatsWithPrices,
            this.state.showSeatsWithoutPrices,
            this.state.showSeatsWithoutTickets
        )
    }

    handleShowSeatsWithoutPrices = () => {
        this.setState({showSeatsWithoutPrices: !this.state.showSeatsWithoutPrices})
        this.updateSeatsAvailability(
            this.state.showSeatsWithPrices,
            !this.state.showSeatsWithoutPrices,
            this.state.showSeatsWithoutTickets
        )
    }

    handleShowSeatsWithoutTickets = () => {
        this.setState({showSeatsWithoutTickets: !this.state.showSeatsWithoutTickets})
        this.updateSeatsAvailability(
            this.state.showSeatsWithPrices,
            this.state.showSeatsWithoutPrices,
            !this.state.showSeatsWithoutTickets
        )
    }

    updateSeatsAvailability = (showSeatsWithPrices, showSeatsWithoutPrices, showSeatsWithoutTickets) => {
        _.forEach(this.smRenderer.context.seats, (seat) => {
            const extendedSeat = this.smRenderer.context.seatToExtendedSeat(seat)
            const ticket = _.find(this.props.tickets, (ticket) => ticket.composite_key === extendedSeat.key)

            if (ticket && ticket.status !== "AVAILABLE") {
                seat.locked = true
                return
            }

            if (showSeatsWithPrices && ticket && extendedSeat.price) {
                seat.locked = false
                return
            }

            if (showSeatsWithoutPrices && ticket && !extendedSeat.price) {
                seat.locked = false
                return
            }

            if (showSeatsWithoutTickets && !ticket) {
                seat.locked = false
                return
            }
            seat.locked = true
        })
        this.smRenderer.redraw()
    }

    showSeatTooltip = (seat) => {
        this.hideTooltips()
        if (seat.locked) {
            return
        }

        this.tooltip.show({
            x: seat.x,
            y: seat.y,
            key: seat.key,
            ticket: _.find(this.props.tickets, (ticket) => ticket.composite_key === seat.key),
            price: seat.price,
            field_width: this.smRenderer.width,
            field_height: this.smRenderer.height,
            onSelectRow: () => this.selectRow(seat.sectionName, seat.rowNumber),
            onSelectSector: () => this.selectSector(seat.sectionName)
        })
    }

    showGaTooltip = (sector) => {
        this.hideTooltips()
        if (!sector.ga) {
            return
        }

        this.gaSelector.show({
            x: sector.rect.left + sector.rect.width/2,
            y: sector.rect.top + sector.rect.height/2,
            name: sector.name,
            price: sector.price,
            amount: this.getSectorTicketsAmount(sector),
            amountAvailable: this.getSectorAvailableTicketsAmount(sector),
            field_width: this.smRenderer.width,
            field_height: this.smRenderer.height,
            onEdit: () => this.switchToGAEdit(sector)
        })
    }

    getSectorTicketsAmount(sector) {
        return _.filter(this.props.tickets, (ticket) => ticket.sector === sector.name).length
    }

    getSectorAvailableTicketsAmount(sector) {
        return _.filter(this.props.tickets, (ticket) => ticket.sector === sector.name && ticket.status === "AVAILABLE").length
    }

    switchToGAEdit(sector) {
        this.props.onEditGASector(sector)
    }

    selectRow(sectorName, rowNumber) {
        const selectedSeatIds = _.map(this.smRenderer.context.cart.seats, (seat) => seat.id)
        const row = _.filter(
            this.smRenderer.context.seats,
            (seat) => {
                if (selectedSeatIds.includes(seat.id)) {
                    return false
                }
                const extendedSeat = this.smRenderer.context.seatToExtendedSeat(seat)
                return extendedSeat.rowNumber === rowNumber && extendedSeat.sectionName === sectorName
            }
        )
        row.forEach(seat => this.smRenderer.handleDestSeatCartSwitch({seat: seat}))
    }

    selectSector(sectorName) {
        const selectedSeatIds = _.map(this.smRenderer.context.cart.seats, (seat) => seat.id)
        const row = _.filter(
            this.smRenderer.context.seats,
            (seat) => {
                if (selectedSeatIds.includes(seat.id)) {
                    return false
                }
                const extendedSeat = this.smRenderer.context.seatToExtendedSeat(seat)
                return extendedSeat.sectionName === sectorName
            }
        )
        row.forEach(seat => this.smRenderer.handleDestSeatCartSwitch({seat: seat}))
    }
}

class ZoomButtons extends Component {
    render () {
        return (
            <div className="seatmap-zoom-buttons">
                <div 
                    className="seatmap-zoom-button"
                    onClick={this.props.onZoomIn} >
                    +
                </div>
                <div 
                    className="seatmap-zoom-button"
                    onClick={this.props.onZoomOut} >
                    &ndash;
                </div>
            </div>
        )
    }
}
